import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSession } from '@/hooks/useSession';
import { useCheckIncludeProfiles } from '@/hooks/useAuthorityLevel';
import usePermission from '@/hooks/usePermission';
import { t } from 'i18next';

export const TabNavbar = ({ selectedTab }) => {
  const navigate = useNavigate();
  const { session } = useSession();
  const profiles = session.user?.profileNames || (session?.user && session?.user['profile-names']) || [];
  if (selectedTab === 'taxonomies' && profiles.includes('Professor')) {
    window.location.pathname = '/ementa/banco-de-questoes';
  }

  return (
    <div className="tab">
      {usePermission('Visualizar lista de ementas, tópicos e subtópicos', 'Ementas') && (
        <div
          className={`tab__link ${selectedTab === 'taxonomies' ? 'active' : ''}`}
          onClick={() => navigate('/ementa/materias')}
        >
          {t('taxonomyAndMaterials.toggleTaxonomies')}
        </div>
      )}

      {usePermission('Visualizar lista de arquivos', 'Arquivos e atividades complementares') && (
        <div
          className={`tab__link ${selectedTab === 'materiais' ? 'active' : ''}`}
          onClick={() => navigate('/ementa/materiais')}
        >
          {t('taxonomyAndMaterials.toggleMaterials')}
        </div>
      )}
    </div>
  );
};
